module.exports = __webpack_public_path__ + "static/img/3.a608dabe.png";